export enum DirectDebitActionTypes {
    GET_ALL_DIRECT_DEBIT = 'GET_ALL_DIRECT_DEBIT',
    GET_ALL_DIRECT_DEBIT_SUCCESS = 'GET_ALL_DIRECT_DEBIT_SUCCESS',
    GET_ALL_DIRECT_DEBIT_FAILURE = 'GET_ALL_DIRECT_DEBIT_FAILURE',

    GET_SINGLE_DIRECT_DEBIT = 'GET_SINGLE_DIRECT_DEBIT',
    GET_SINGLE_DIRECT_DEBIT_SUCCESS = 'GET_SINGLE_DIRECT_SUCCESS',
    GET_SINGLE_DIRECT_DEBIT_FAILURE = 'GET_SINGLE_DIRECT_FAILURE',

    SEND_DIRECT_DEBIT_DRAFT = 'SEND_DIRECT_DEBIT_DRAFT',
    SEND_DIRECT_DEBIT_DRAFT_SUCCESS = 'SEND_DIRECT_DEBIT_SUCCESS',
    SEND_DIRECT_DEBIT_DRAFT_FAILURE = 'SEND_DIRECT_DEBIT_FAILURE',

    GET_DIRECT_DEBIT_STATUS = 'GET_DIRECT_DEBIT_STATUS',
    GET_DIRECT_DEBIT_STATUS_SUCCESS = 'GET_DIRECT_DEBIT_SUCCESS',
    GET_DIRECT_DEBIT_STATUS_FAILURE = 'GET_DIRECT_DEBIT_STATUS_FAILURE',

    CREATE_DIRECT_DEBIT = 'CREATE_DIRECT_DEBIT',
    CREATE_DEIRECT_DEBIT_FAILURE = 'CREATE_DEIRECT_DEBIT_FAILURE',
    CREATE_DIRECT_DEBIT_SUCCESS = 'CREATE_DIRECT_DEBIT_SUCCESS',

    CLEAR_DIRECT_DEBIT_LOADING = 'CLEAR_DIRECT_DEBIT_LOADING',
    CLEAR_DIRECT_DEBIT_ERROR = 'CLEAR_DIRECT_DEBIT_ERROR',
    CLEAR_DIRECT_DEBIT_SUCCESS = 'CLEAR_DIRECT_DEBIT_SUCCESS',

    EDIT_DIRECT_DEBIT_LOADING = 'EDIT_DIRECT_DEBIT_LOADING',
    EDIT_DIRECT_DEBIT_SUCCESS = 'EDIT_DIRECT_DEBIT_SUCCESS',
    EDIT_DIRECT_DEBIT_FAILURE = 'EDIT_DIRECT_DEBIT_FAILURE',

    DELETE_DIRECT_DEBIT_LOADING = 'DELETE_DIRECT_DEBIT_LOADING',
    DELETE_DIRECT_DEBIT_SUCCESS = 'DELETE_DIRECT_DEBIT_SUCCESS',
    DELETE_DIRECT_DEBIT_FAILURE = 'DELETE_DIRECT_DEBIT_FAILURE',

    SCHEDULE_CUSTOMER_DEBIT = 'SCHEDULE_CUSTOMER_DEBIT',
    SCHEDULE_CUSTOMER_DEBIT_SUCCESS = 'SCHEDULE_CUSTOMER_DEBIT_SUCCESS',
    SCHEDULE_CUSTOMER_DEBIT_FAILURE = 'SCHEDULE_CUSTOMER_DEBIT_FAILURE',

    GET_DIRECT_DEBIT_TRANSACTIONS = 'GET_DIRECT_DEBIT_TRANSACTIONS',
    GET_DIRECT_DEBIT_TRANSACTIONS_SUCCESS = 'GET_DIRECT_DEBIT_TRANSACTIONS_SUCCESS',
    GET_DIRECT_DEBIT_TRANSACTIONS_FAILURE = 'GET_DIRECT_DEBIT_TRANSACTIONS_FAILURE',

    CANCEL_SUBSCRIPTION = 'CANCEL_DIRECT_SUBSCRIPTION',
    CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_DIRECT_SUBSCRIPTION_SUCCESS',
    CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_DIRECT_SUBSCRIPTION_FAILURE',

    CLEAR_DIRECT_DEBIT_STATE = 'CLEAR_DIRECT_DEBIT_STATE',
}
